import { createSlice } from "@reduxjs/toolkit";
import { errorSideEffects, loadingSideEffects, RTKSideEffectSchema, successSideEffects, updatingSideEffects } from "../..";
import { APIErrorResponseSchema } from "../../../actions";
import { Toastify } from "../../../../components/Toaster";
import { isEmptyArray } from "../../../../utils";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface DomainAccessManagementState extends RTKSideEffectSchema, APIErrorResponseSchema, MutationTrackingState {
  Data?: {
    IsEnabled: boolean;
    Allowlist?: string[];
    Blocklist?: string[];
  };
}

const initialState: DomainAccessManagementState = {
  isLoading: false,
  isUpdating: false,
  isSuccess: false,
  isError: false,
  error: null,
  Data: {
    IsEnabled: false,
    Allowlist: [""],
    Blocklist: [""]
  }
};

const domainAccessManagementSlice = createSlice({
  name: "domainAccessManagement",
  initialState,
  reducers: {
    getDomainAccessManagementRequest(state) {
      Object.assign(state, loadingSideEffects);
    },
    getDomainAccessManagementSuccess(state, action) {
      Object.assign(state, successSideEffects);
      const allowlist = action.payload.data.Allowlist;
      const blocklist = action.payload.data.Blocklist;
      const data = {
        IsEnabled: isEmptyArray(action.payload.data.Allowlist) && isEmptyArray(action.payload.data.Blocklist) ? false : true,
        Allowlist: !allowlist || (Array.isArray(allowlist) && allowlist.length === 0) ? [""] : allowlist,
        Blocklist: !blocklist || (Array.isArray(blocklist) && blocklist.length === 0) ? [""] : blocklist
      };
      state.Data = data;
    },
    getDomainAccessManagementError(state, action) {
      Object.assign(state, errorSideEffects);
      state.error = action.payload;
    },
    updateDomainAccessManagementRequest(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updateDomainAccessManagementSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state, "success"));
      const allowlist = action.payload.data.Allowlist;
      const blocklist = action.payload.data.Blocklist;
      const data = {
        IsEnabled: isEmptyArray(action.payload.data.Allowlist) && isEmptyArray(action.payload.data.Blocklist) ? false : true,
        Allowlist: !allowlist || (Array.isArray(allowlist) && allowlist.length === 0) ? [""] : allowlist,
        Blocklist: !blocklist || (Array.isArray(blocklist) && blocklist.length === 0) ? [""] : blocklist
      };
      state.Data = data;
      Toastify("success", "Domain Access Management updated successfully");
    },
    updateDomainAccessManagementError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state, "error"));
      state.error = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const {
  getDomainAccessManagementRequest,
  getDomainAccessManagementSuccess,
  getDomainAccessManagementError,
  updateDomainAccessManagementRequest,
  updateDomainAccessManagementSuccess,
  updateDomainAccessManagementError
} = domainAccessManagementSlice.actions;

export default domainAccessManagementSlice.reducer;
